import { EventEmitter } from '@angular/core';
import { ElementRef } from '@angular/core';
var PASSWORD_TYPE = 'password';
var TEXT_TYPE = 'text';
var UIInputDirective = /** @class */ (function () {
    function UIInputDirective(_elementRef) {
        this._elementRef = _elementRef;
        this.onBlur = new EventEmitter();
        this.onFocus = new EventEmitter();
    }
    Object.defineProperty(UIInputDirective.prototype, "value", {
        get: function () {
            return this._elementRef.nativeElement.value;
        },
        set: function (value) {
            this._elementRef.nativeElement.value = value;
        },
        enumerable: true,
        configurable: true
    });
    UIInputDirective.prototype.ngOnInit = function () {
        this._sourceType = this.type;
    };
    UIInputDirective.prototype.nowPassword = function () {
        return (this.type === PASSWORD_TYPE);
    };
    UIInputDirective.prototype.isPassword = function () {
        return (this._sourceType === PASSWORD_TYPE);
    };
    UIInputDirective.prototype.togglePasswordType = function () {
        var newType = this.type === PASSWORD_TYPE ? TEXT_TYPE : PASSWORD_TYPE;
        this._elementRef.nativeElement.setAttribute('type', newType);
        this.type = newType;
    };
    UIInputDirective.prototype._onBlur = function () {
        this.onBlur.emit();
    };
    UIInputDirective.prototype._onFocus = function () {
        this.onFocus.emit();
    };
    return UIInputDirective;
}());
export { UIInputDirective };
